//
//
//
//
//
//
import TrustCenter from "./center/TrustCenter.vue";
export default {
  components: {
    TrustCenter: TrustCenter
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},
  methods: {}
};